// Registration is operational; it never establishes attendance or cash allocation.
function eventRegistration(row) {
  const status = row.participationStatus || row.status || 'unknown';
  if (row.ambiguousStatus || row.missingReference) return 'unknown';
  if (status === 'cancelled') return 'cancelled';
  if (['registered', 'attended', 'didNotAttend'].includes(status) || row.registeredAt || row.registrationVerified) return 'registered';
  const payments = row.payments || [];
  if (payments.some(payment => !payment.voided && (Number(payment.grossAmount) > 0 || Number(payment.amount) > 0))) return 'registered';
  const canonical = payments.some(payment => payment.source === 'receipt');
  if (!canonical && !row.legacySuppressed && Number(row.legacyRecordedAmount ?? row.amountPaid) > 0) return 'registered';
  return 'unknown';
}
export { eventRegistration };
